import React from 'react';
import './noEmployeeDetails.scss';
import noResult from '../../../Assets/images/svg/dar_no_result.svg';
import PropTypes from 'prop-types';

const NoEmployeeDetails = ({ noEmployeeCss, message }) => {
  return (
    <div className={`no-employee-data ${noEmployeeCss}`}>
      <img src={noResult} alt="no_data"></img>
      <span> {message}</span>
    </div>
  );
};

NoEmployeeDetails.propTypes = {
  noEmployeeCss: PropTypes.string,
  message: PropTypes.string,
};

export default NoEmployeeDetails;
